import React, { useState, useEffect } from 'react';
import { connect, useDispatch  } from 'react-redux';
import { Link } from 'react-router-dom';
import '../../assets/style.scss';
import { getPromotedEvents } from '../../redux/actions/index';
import {PromotedEventType } from '../interfaces';
import { mediaQuery } from '../../helpers/utils';
import './front-page.scss';


const PromoEvent = (props: {eventObject: PromotedEventType}) => {
    const { eventObject } = props;
    let width = '175px';
    let height =  '219px';
    if (mediaQuery('(max-width: 411px)')) {
        width = '185px';
        height = '232px';
    }
    if (mediaQuery('(max-width: 380px)')) {
        width = '165px';
        height = '206px';
    }
    if (mediaQuery('(max-width: 320px)')) {
        width = '135px';
        height = '169px';
    }
    if (mediaQuery('(max-width: 280px)')) {
        width = '124px';
        height = '155px';
    }
    const st = {
        backgroundImage: `url("${eventObject.image}")`,
        backgroundSize: 'cover',
        width,
        height,
    }
    return <Link to={eventObject.url}><div style={st} className='promoted-event-placeholder' /></Link>


}

const PromoPage = (props: any) => {
    const {promotedEvents} = props;
    const dispatch = useDispatch();
    const [classes, setClasses] = useState('promo-block');
    useEffect(() => {
        //if (!promotedEvents || promotedEvents.total === null) {
        dispatch(getPromotedEvents());
        //}
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    if (mediaQuery('(min-width: 411px)')) {
        if(classes === 'promo-block') {
            setClasses(`${classes} desktop`);
        }
    }
    if (!promotedEvents.events || !promotedEvents.events.length) {
        return <></>
    }

    return (<div className={classes}>
        {promotedEvents.events.map((ev: PromotedEventType, idx: number) => {
            const dateTimeString = ev.period.end ? `${ev.period.start} - ${ev.period.end}` : ev.period.start;
            return <div className="promo-event" key={idx}>
                <PromoEvent eventObject={ev}/>

                <div className="promo-name">
                    <Link to={ev.url}>{ev.name}</Link>
                </div>
                <div className="promo-times">
                    <Link to={ev.url}>{dateTimeString}</Link>
                </div>
                <div className="promo-place">
                    <Link to={ev.url}>{ev.place_name}</Link>
                </div>

            </div>
        })}
    </div>)
}



const mapStateToProps = ( state: any ) => {
    return state;
}

export default connect(mapStateToProps, {getPromotedEvents})(PromoPage);
